<template>
  <div>
  <div id="container" class="wrap">
    <div id="side">
      <div id="likes" class="section">
        <div v-if="desktop" id="ad" class="section">
          <iframe src="/ad.php" class="iframe-ad" style="border: none;margin-top: 0px!important;margin-left: -39px;height: 115px;width: 328px;" scrolling="no"></iframe>
        </div>
        <div v-if="(!likeids.length && noaparecer)" id="main">
           <h1 style="font-size: 20px;margin: 0;padding: 0;font-weight: 400;">Gradients for Designers and Artists</h1>
           <h2 style="font-size: 14px;font-weight: 400;margin: 10px 0px 20px;">Gradient Hunt is a free and open platform for color inspiration with thousands of trendy hand-made color gradients</h2>
        </div>
        <div v-if="likeids.length" class="title">You liked <router-link to="/likes"><span>{{ likeids.length }}</span> gradients</router-link></div>
        <!-- preload -->
        <div v-if="preloadlikes" style="height: 65px;" class="list">
        <div class="palette preload" style="width: 66px;height: 46px;z-index:1">
          <svg viewBox="0 0 350 245" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs>
                  <linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="linearGradient-1">
                      <stop stop-color="#E5EBEE" offset="0%"></stop>
                      <stop stop-color="#F4F4F4" offset="100%"></stop>
                  </linearGradient>
              </defs>
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="image">
                      <rect id="Rectangle-path" fill="#E5EBEE" fill-rule="nonzero" x="0" y="216" width="350" height="13" rx="6.5"></rect>
                      <rect id="Rectangle-path" fill="#E5EBEE" fill-rule="nonzero" x="0" y="232" width="203" height="13" rx="6.5"></rect>
                      <rect id="Rectangle" fill="url(#linearGradient-1)" x="0" y="0" width="350" height="203" rx="6"></rect>
                  </g>
              </g>
          </svg>
        </div>
        <div class="palette preload" style="width: 66px;height: 46px;z-index:2">
          <svg viewBox="0 0 350 245" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs>
                  <linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="linearGradient-1">
                      <stop stop-color="#E5EBEE" offset="0%"></stop>
                      <stop stop-color="#F4F4F4" offset="100%"></stop>
                  </linearGradient>
              </defs>
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="image">
                      <rect id="Rectangle-path" fill="#E5EBEE" fill-rule="nonzero" x="0" y="216" width="350" height="13" rx="6.5"></rect>
                      <rect id="Rectangle-path" fill="#E5EBEE" fill-rule="nonzero" x="0" y="232" width="203" height="13" rx="6.5"></rect>
                      <rect id="Rectangle" fill="url(#linearGradient-1)" x="0" y="0" width="350" height="203" rx="6"></rect>
                  </g>
              </g>
          </svg>
        </div>
        <div class="palette preload" style="width: 66px;height: 46px;z-index:3">
          <svg viewBox="0 0 350 245" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs>
                  <linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="linearGradient-1">
                      <stop stop-color="#E5EBEE" offset="0%"></stop>
                      <stop stop-color="#F4F4F4" offset="100%"></stop>
                  </linearGradient>
              </defs>
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="image">
                      <rect id="Rectangle-path" fill="#E5EBEE" fill-rule="nonzero" x="0" y="216" width="350" height="13" rx="6.5"></rect>
                      <rect id="Rectangle-path" fill="#E5EBEE" fill-rule="nonzero" x="0" y="232" width="203" height="13" rx="6.5"></rect>
                      <rect id="Rectangle" fill="url(#linearGradient-1)" x="0" y="0" width="350" height="203" rx="6"></rect>
                  </g>
              </g>
          </svg>
        </div>
    </div>
    <!-- end of preload -->
        <div class="list">
          <div v-for="(likeid, index) in likeids" :key="likeid.id" class="palette" style="margin-right: 35px;">
            <div class="place c1" style="width: 79px;height: 23px;" :style="likeid.gradient"><router-link v-bind:to="'/gradient/' + likeid.id"></router-link></div>
            <div @click="dislikeSide(likeid.id,index)" class="remove"><img alt="gradienthunt_x_icon" src="/img/icon_remove.png" /></div>
          </div>
        </div>
      </div>
      <div id="extension" class="section">
        <div style="margin-bottom: 42px;margin-top: -13px;">
        <div class="title">Subscribe to our newsletter</div>
        <input v-model="email" @keyup.enter="trigger" style="font-size:15px;width: 80%;float: left;margin-bottom: 8px;" type="text" placeholder="Email" value="" />
        <button @click="enviaremail" ref="sendReply" class="button" style="width:18%;float:right;height: 36px;background-color:#eaf2f9;margin-bottom: 8px;font-weight: 700;">Ok</button>
      </div>
        <p v-if="showinvalid" style="margin-bottom: 8px;color:#c9302c">Invalid email format</p>
        <p v-if="showalready" style="margin-bottom: 8px;color:#c9302c">This email is already subscribed</p>
        <p v-if="showsuccess" style="margin-bottom: 8px;color: #79C698;">You have been succesfully subscribed to our newsletter</p>

        <div style="margin-top: 7px;" class="title">Take a look to our partner sites</div>
        <a target="_blank" style="text-decoration:none;background-color: #f1f7f9;border: 1px solid #ccc;" class="button" href="https://qr.io"><img alt="QR.io - Generate QR codes" src="https://qr.io/logo/logo.png" />QR Code Generator</a>
        <a target="_blank" style="text-decoration:none;background-color: #f1f7f9;border: 1px solid #ccc;" class="button" href="https://htmlcolors.com"><img alt="Html Colors" src="https://htmlcolors.com/favicon.png" />Html Colors</a>
        <a target="_blank" style="text-decoration:none;background-color: #f1f7f9;border: 1px solid #ccc;" class="button" href="https://colorpalettes.com"><img style="width: 26px;top:6px;" alt="Color Palettes" src="https://colorpalettes.com/img/palettegreen-vector.png" />Color Palettes</a>
      </div>
      <div style="margin-top:5px" id="credit" class="section">
        Made with <img src="/img/icon-heart-blue.png"></img> by <a target="_blank" href="https://twitter.com/fmaldonadoy">Franco Maldonado</a>
    </div>
    </div>
  <div id="feed">
  <div id="bank">
    <div v-if="mobile" id="ad" class="section">
      <iframe src="/ad.php" class="iframe-ad" style="border: none;margin: 0 auto!important;height: 115px;width: 328px;" scrolling="no"></iframe>
    </div>
<!-- preload -->
<div v-if="preload">
<div style="z-index:1" class="item block preload">
  <svg viewBox="0 0 350 245" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
          <linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="linearGradient-1">
              <stop stop-color="#E5EBEE" offset="0%"></stop>
              <stop stop-color="#F4F4F4" offset="100%"></stop>
          </linearGradient>
      </defs>
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="image">
              <rect id="Rectangle-path" fill="#E5EBEE" fill-rule="nonzero" x="0" y="216" width="350" height="13" rx="6.5"></rect>
              <rect id="Rectangle-path" fill="#E5EBEE" fill-rule="nonzero" x="0" y="232" width="203" height="13" rx="6.5"></rect>
              <rect id="Rectangle" fill="url(#linearGradient-1)" x="0" y="0" width="350" height="203" rx="6"></rect>
          </g>
      </g>
  </svg>
</div>
<div style="z-index:2" class="item block preload">
  <svg viewBox="0 0 350 245" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
          <linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="linearGradient-1">
              <stop stop-color="#E5EBEE" offset="0%"></stop>
              <stop stop-color="#F4F4F4" offset="100%"></stop>
          </linearGradient>
      </defs>
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="image">
              <rect id="Rectangle-path" fill="#E5EBEE" fill-rule="nonzero" x="0" y="216" width="350" height="13" rx="6.5"></rect>
              <rect id="Rectangle-path" fill="#E5EBEE" fill-rule="nonzero" x="0" y="232" width="203" height="13" rx="6.5"></rect>
              <rect id="Rectangle" fill="url(#linearGradient-1)" x="0" y="0" width="350" height="203" rx="6"></rect>
          </g>
      </g>
  </svg>
</div>
<div style="z-index:3" class="item block preload">
  <svg viewBox="0 0 350 245" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
          <linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="linearGradient-1">
              <stop stop-color="#E5EBEE" offset="0%"></stop>
              <stop stop-color="#F4F4F4" offset="100%"></stop>
          </linearGradient>
      </defs>
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="image">
              <rect id="Rectangle-path" fill="#E5EBEE" fill-rule="nonzero" x="0" y="216" width="350" height="13" rx="6.5"></rect>
              <rect id="Rectangle-path" fill="#E5EBEE" fill-rule="nonzero" x="0" y="232" width="203" height="13" rx="6.5"></rect>
              <rect id="Rectangle" fill="url(#linearGradient-1)" x="0" y="0" width="350" height="203" rx="6"></rect>
          </g>
      </g>
  </svg>
</div>
<div style="display:none;z-index:4" class="item block preload celpreload">
  <svg viewBox="0 0 350 245" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
          <linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="linearGradient-1">
              <stop stop-color="#E5EBEE" offset="0%"></stop>
              <stop stop-color="#F4F4F4" offset="100%"></stop>
          </linearGradient>
      </defs>
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="image">
              <rect id="Rectangle-path" fill="#E5EBEE" fill-rule="nonzero" x="0" y="216" width="350" height="13" rx="6.5"></rect>
              <rect id="Rectangle-path" fill="#E5EBEE" fill-rule="nonzero" x="0" y="232" width="203" height="13" rx="6.5"></rect>
              <rect id="Rectangle" fill="url(#linearGradient-1)" x="0" y="0" width="350" height="203" rx="6"></rect>
          </g>
      </g>
  </svg>
</div>
</div>
<!-- end of preload -->
    <div v-for="(id, index) in ids" class="item block shadow">
      <div class="palette">
        <div class="place c1" :style="id.gradient"><router-link v-bind:to="'/gradient/' + id.id"></router-link><span v-if="copiar" v-on:click="showAlert" v-clipboard:copy="id.gradient">Copy Gradient Code</span><span v-if="copiedg" style="z-index:1">Copied</span></div>
      </div>
      <div v-on:click="like(id.id,index)" v-if="!id.liked" class="like button">
        <img alt="gradienthunt_heart_icon" src="/img/icon-heart.png" />
        <span>{{ id.likes }}</span>
      </div>
      <div v-on:click="dislike(id.id,index)" v-if="id.liked" style="background-color: #F5FCFF;color: #70A1D4;" class="like button">
        <img style="filter: brightness(300%);" alt="gradienthunt_heart_icon" src="/img/icon-heart.png" />
        <span>{{ id.likes }}</span>
      </div>
      <span class="date">{{ id.date }}</span>
    </div>
    <center>
    <img v-if="(scrollload && !preload)" src="/img/loader.gif"></img>
    <h2 v-if="nomore">No More Gradients!<br>Help us grow the collection by creating one!</h2>
  </center>
    </div>
    </div>
  </div>
</div>
</template>
<style>
#hideMe {
    -moz-animation: cssAnimation 0.2s ease-in 1.7s forwards;
    /* Firefox */
    -webkit-animation: cssAnimation 0.2s ease-in 1.7s forwards;
    /* Safari and Chrome */
    -o-animation: cssAnimation 0.2s ease-in 1.7s forwards;
    /* Opera */
    animation: cssAnimation 0.2s ease-in 1.7s forwards;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
}
@keyframes cssAnimation {
    to {
        width:0;
        height:0;
        opacity: 0;
        overflow:hidden;
    }
}
@-webkit-keyframes cssAnimation {
    to {
        width:0;
        height:0;
        opacity: 0;
        visibility:hidden;
    }
}
.preload:before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: block;
    background: linear-gradient(90deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.5),hsla(0,0%,100%,0));
    -webkit-animation: _1IOU .8s linear infinite;
    animation: _1IOU .8s linear infinite;
}
@-webkit-keyframes _1IOU {
            0% {
                -webkit-transform: translateX(-100%);
                transform: translateX(-100%)
            }
            to {
                -webkit-transform: translateX(100%);
                transform: translateX(100%)
            }
        }

        @keyframes _1IOU {
            0% {
                -webkit-transform: translateX(-100%);
                transform: translateX(-100%)
            }
            to {
                -webkit-transform: translateX(100%);
                transform: translateX(100%)
            }
        }
        @media (max-width:1360px) {
          .celpreload{
            display: inline-block!important;
          }
        }
        @media (min-width:1720px) {
          .celpreload{
            display: inline-block!important;
          }
        }
</style>

  <script>
  export default {
    data(){
      return{
      copiedg: false,
      copiar: true,
      preload: true,
      preloadlikes: true,
      ids: [],
      likeids: [],
      submit: "yes",
      delete: "delete",
      noaparecer: false,
      scrollload: true,
      nomore: false,
      cargando: false,
      contador: 1,
      email: "",
      showinvalid: false,
      showalready: false,
      showsuccess: false,
      mobile: false,
      desktop: false
      }
    },
    methods:{
        showAlert:function(){
          this.copiedg = true;
          this.copiar = false;
            setTimeout(() => {
              this.copiedg = false;
              this.copiar = true;
            }, 1000);
    },
        NewGradients:function(){
          axios.post('/newgradients.php', {
              submit: this.submit
            })
            .then(response => {
              this.ids = response.data;
              console.log(response.data);
              this.preload = false;
          })
            .catch(function (error) {
              console.log(error);
            });
    },
    like:function(msg,ind){
      var liked = msg;
      var ind = ind;
      axios.post('/likes.php', {
          liked: liked,
          submit: this.submit
        })
        this.ids[ind].likes = parseInt(this.ids[ind].likes)+1;
        this.ids[ind].liked = true;
        this.likeids.unshift({ gradient: this.ids[ind].gradient, id: this.ids[ind].id });
    },
    dislike:function(msg,ind){
      var liked = msg;
      var ind = ind;
      axios.post('/likes.php', {
          liked: liked,
          delete: this.delete
        })
         var parentid = this.getparent(liked);
         this.likeids.splice(parentid,1);

        this.ids[ind].likes = parseInt(this.ids[ind].likes)-1;
        this.ids[ind].liked = false;
    },
    dislikeSide:function(msg,ind){
      var liked = msg;
      var ind = ind;
      axios.post('/likes.php', {
          liked: liked,
          delete: this.delete
        })
        var parentidside = this.getparentSide(liked);
        this.ids[parentidside].likes = parseInt(this.ids[parentidside].likes)-1;
        this.ids[parentidside].liked = false;
        // this.ids[ind].likes = parseInt(this.ids[ind].likes)-1;
        // this.ids[ind].liked = false;
        this.likeids.splice(ind,1);
    },
    LikesGradients:function(){
      axios.post('/likesgradients.php', {
          submit: this.submit
        })
        .then(response => {
          this.likeids = response.data;
          console.log(response.data);
          this.preloadlikes = false;
          this.noaparecer = true;
      })
        .catch(function (error) {
          console.log(error);
        });
    },
    getparent:function(elid){
          var elid = elid;
          var arr = this.likeids;
          var num = 0;
          var num2 = 0;
          // console.log("jeje");
          // console.log(elid);
          // console.log(arr);

          arr.forEach(element => {
            var unid = element.id;
            // console.log(elid);

            if(unid == elid){
              // console.log('yes');
              // alert(num);
              // return num;
              num2 = num;
            }else{
              // console.log('no');
            }
        num = num+1;
          });
          return num2;
    },
    getparentSide:function(elid){
          var elid = elid;
          var arr = this.ids;
          var num = 0;
          var num2 = 0;

          // console.log("jeje");
          // console.log(elid);
          // console.log(arr);

          arr.forEach(element => {
            var unid = element.id;
            // console.log(elid);

            if(unid == elid){
              // console.log('yes');
              // alert(num);
              // return num;
              num2 = num;

            }else{
              // console.log('no');
            }
        num = num+1;
          });
          return num2;
    },
    scrollmore () {
  window.onscroll = () => {
  // let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;

if (((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight - 2) && !this.cargando ) {
  this.cargando = true;
    if(this.scrollload){
    axios.post('/scrollmore.php', {
        submit: this.submit,
        contador: this.contador
      })
      .then(response => {

        var concat2 = response.data;

        concat2.forEach(element => {
          this.ids.push(element);
          // console.log(element);
          });
    if(concat2.length > 29){
       this.scrollload = true;
    }
    if(concat2.length < 30){
      this.scrollload = false;
      this.nomore = true;
    }
    this.contador = this.contador+1;
    this.cargando = false;
  })
  }
}
}
},
enviaremail() {
 axios.post('/validaremail.php', {
     email: this.email,
     submit: this.submit
   })
   .then(response => {
     if(response.data == 'invalid'){
     this.showinvalid = true;
     this.showalready = false;
     this.showsuccess = false;
         }
     if(response.data == 'This email is already subscribed'){
     this.showalready = true;
     this.showinvalid = false;
     this.showsuccess = false;
         }
     if(response.data == 'You have been succesfully subscribed to our newsletter'){
     this.showsuccess = true;
     this.showinvalid = false;
     this.showalready = false;
         }
   console.log(response.data);
   })
   .catch(function (error) {
     console.log(error);
   });
},
browser:function(){
  axios.post('/browser.php', {
    })
    .then(response => {
      if(response.data == 'mobile'){
      this.mobile = true;
      this.desktop = false;
          }
      if(response.data == 'desktop'){
      this.mobile = false;
      this.desktop = true;
          }
  })
    .catch(function (error) {
      console.log(error);
    });
},
trigger () {
  this.$refs.sendReply.click()
}
  },
  mounted(){
  this.NewGradients();
  this.LikesGradients();
  this.scrollmore();
  this.browser();
}}
  </script>



// WEBPACK FOOTER //
// src/New.vue